import React, { useEffect, useState } from "react";
import styles from "./school-levels-grades.module.css";
import { Typography } from "antd";
import CustomButton from "../../../../../../../common/custom-button/custom-button";
import { PlusOutlined } from "@ant-design/icons";
import CustomTable from "../../../../../../../common/custom-table/custom-table";
import SVGIcon from "../../../../../../../constants/SVGIcon";
import { deleteLevel, fetchClass } from "../../../../../../../services/student";
import AddEditLevels from "./components/add-edit-levels/add-edit-levels";
import CustomPopover from "../../../../../../../common/custom-popover/custom-popover";
import { refetchSchool } from "../../../../../../../utils/common";

const SchoolLevelsGrades = () => {
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setPageNo(1);
    getLevels();
  }, []);

  const getLevels = async (tempPage = pageNo, tempPageSize = pageSize) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };
      const response = await fetchClass(payload);
      if (response?.data) {
        const data = response?.data?.data?.levels;
        setLevels(data);
        setTotalCount(response?.data?.data?.totalRecords);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getLevels(page, pageSize);
  };

  const handleEditLevel = (data) => {
    setEditDetails(data);
    setOpenDrawer(true);
  };

  const handleOnClose = () => {
    getLevels();
    setOpenDrawer(false);
  };

  const handleDeleteLevel = async (id) => {
    try {
      await deleteLevel(id);
      getLevels();
      refetchSchool();
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddLevels = () => {
    setEditDetails(null);
    setOpenDrawer(true);
  };

  const columns = [
    {
      title: "Level Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      render: (value) => value || "-",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div className={styles.actionItemWrapper}>
          <SVGIcon
            name={"edit-icon"}
            width={"20"}
            height={"20"}
            stroke={"#3BB44B"}
            onClick={() => handleEditLevel(record)}
          />
          <CustomPopover
            message="Are you sure you want to delete this levels?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={() => handleDeleteLevel(record?.id)}
          >
            <SVGIcon
              name={"delete"}
              width={"20"}
              height={"20"}
              stroke={"rgba(243, 17, 17, 1)"}
            />
          </CustomPopover>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={styles.titleContainer}>
        <Typography className={styles.tabTitle}>
          Level/Grades
        </Typography>
        <CustomButton
          title="Add New Level"
          size="large"
          icon={<PlusOutlined />}
          onClick={handleAddLevels}
        />
      </div>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={levels}
          loading={loading}
          headerColor="#667085"
          headerBackgroundColor="#F9FAFB"
          total={totalCount}
          pageSize={pageSize}
          currentPage={pageNo}
          handlePageChange={handleChangePage}
        />
      </div>
      <AddEditLevels
        open={openDrawer} 
        onClose={handleOnClose} 
        data={editDetails}
      />
    </div>
  );
};

export default SchoolLevelsGrades;